// Phone search normalisation — MUST stay in sync with
// booking.fn_phone_search_key(text) (RealityDatabase migration
// 20260904101813_booking_customer_phone_search_key.sql), which feeds the
// generated booking.customers.phone_search column we filter on.
//
// Rule: digits only; "+31" / "0031" / bare "31…" (11+ digits) drop the
// country code and an optional trunk "(0)"; national "06…" drops the
// trunk 0; other countries keep their country code.
//   "+31 6 12345678" → "612345678"
//   "06-12345678"    → "612345678"
//   "+49 170 123"    → "49170123"
export function phoneSearchKey(raw: string): string {
  const intl = /^\s*(\+|00)/.test(raw);
  const n = raw.replace(/\D/g, '').replace(/^00/, '');
  if (n.startsWith('31') && (intl || n.length >= 11)) {
    return n.slice(2).replace(/^0/, '');
  }
  if (intl) return n;
  return n.replace(/^0/, '');
}

// True when the typed search term is a phone-ish fragment: nothing but
// digits, separators and a leading "+", with at least 3 digits left after
// normalisation. Keeps names, e-mails and NEO-numbers out of the phone
// branch (and stops "06" alone from matching every mobile number).
export function looksLikePhoneFragment(term: string): boolean {
  const t = term.trim();
  if (!/^\+?[\d\s\-().]+$/.test(t)) return false;
  return phoneSearchKey(t).length >= 3;
}
